/**
 * Heading for the dashboard's Upcoming Meetings card when the chosen day has none.
 * `dayLabel` is the day picker's label: "Today", "Tomorrow", or e.g. "Friday, Oct 9".
 */
export function getEmptyMeetingsTitle(dayLabel) {
  if (dayLabel === "Today" || dayLabel === "Tomorrow") {
    return `No meetings ${dayLabel.toLowerCase()}`;
  }
  return dayLabel ? `No meetings on ${dayLabel}` : "No meetings scheduled";
}
